import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/index/codepoints")({
  component: () => <Outlet />,
});
